import { axiosClient } from "services/axios";

async function loginRequest({ login, password }) {
  try {
    return await axiosClient.post("account/auth", {
      login,
      password,
    });
  } catch (e: any) {
    console.log(e);
    return e?.response;
  }
}

export { loginRequest };
